// extracted by mini-css-extract-plugin
export default {"all-events":"EventDetails_all-events__xHaha"};